import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TinyColor } from '@ctrl/tinycolor';
import { Subject, take } from 'rxjs';
import { CustomFileDownloaderComponent } from 'src/app/core/custom-file-downloader/custom-file-downloader.component';
import { fileRequest } from 'src/app/model/request/file';
import { CryptHelperService } from 'src/app/services/helpers/crypt-helper.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { environment } from 'src/environments/environment';
import { DocumentiService } from '../../gestione-documenti/documenti.service';
import { TicketsBaseResponse, TicketsResponse } from '../tickets';
import { TicketsService } from '../tickets.service';
import _ from 'lodash';

@Component({
  selector: 'app-tracking-ticket',
  templateUrl: './tracking-ticket.component.html',
  styleUrl: './tracking-ticket.component.scss'
})
export class TrackingTicketComponent implements OnInit, OnDestroy {
  @ViewChild('downloader') downloader?: CustomFileDownloaderComponent;

  codice: string = '';

  showDoc: boolean = false;

  isMobile: boolean = false;

  error: boolean = false;

  private theEnd$ = new Subject<void>();



  ticket?: TicketsResponse;

  idStatoDocumento: number = 0;
  req?: fileRequest;
  bgUrl: string = `${environment.baseHREF}${environment.logo}`;

  color?: string;

  logo?: string;
  documento: any;
  response: any;
  data: any;
  colli: any;


  constructor(
    private localStorageS: LocalStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private documentiS: DocumentiService,
    private ticketS: TicketsService,
    private crypter: CryptHelperService
  ) {


    if (window.innerHeight > window.innerWidth) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    if (window.innerHeight > window.innerWidth) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  ngOnInit(): void {

    //this.nrDocumento = this.route.snapshot.paramMap.get('id') || ''
    this.codice = this.router.url.split('/')[this.router.url.split('/').length - 1]

    //this.nrDocumento = this.crypter.decryptStringAlt(this.nrDocumento);
    console.warn('CODICE')
    console.log(this.codice)

    this.ticketS.getTicketByTracking(this.codice).pipe(take(1)).subscribe({
      next:(resp: TicketsBaseResponse)=>{
        console.warn(resp)
        this.ticket = _.cloneDeep(resp.data);
        setTimeout(() => {
          
          this.showDoc = true;
        }, 10);
      }
    }) 





  }


  ngOnDestroy(): void {
    this.theEnd$.unsubscribe()
    console.log('DESTROYED THE MF')
  }

  ngAfterViewInit(): void {
    console.log('INITIATED THE MF')
  }




}
